<template>
  <!-- レイアウトファイル（components/layouts/*）から呼び出される唯一の窓口。
       開閉ハンドラとモーダル本体を本コンポーネント内で完結させ、wabunka-src 外から
       useGlobalModal などの一般用フレームワークに依存しないようにする -->
  <KeywordSearchModal :on-close="close" :should-show-modal="isOpen" />
</template>

<script setup lang="ts">
import KeywordSearchModal from '@/wabunka-src/features/Search/components/general/KeywordSearchModal/KeywordSearchModal.vue';
import { useKeywordSearchModal } from '@/wabunka-src/features/Search/composables/general/useKeywordSearchModal';

const { isOpen, close } = useKeywordSearchModal();
</script>
